import type { FaireProductEntity } from "../../entity_types/product";

export const p_mkhrqa2y4t: FaireProductEntity = {
  token: "p_mkhrqa2y4t",
  type: "product",
  name: "No. 9 Gift Set",
  brandToken: "b_4qzg2a3z5n",
  brandName: "Freedom Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/decca56b6a4df29b283d100d1f8cc1b5eca5e9e63c932ed52879bc47e303c069.png",
  galleryImageUrls: [],
  priceDollars: 30,
  description:
    "Luxurious, pampering soap, lotion and candle gift set.\n\nSet includes:\n\n8 oz Lotion\n8 oz Soap\n7.5 oz Woodwick Candle\n\nSimply Perfect Sunday is the line of bath and beauty products created for Simply Perfect by Freedom Studios in Sioux Falls, SD.\n\nFor busy women – which means all women – Sunday is the time to relax, unplug and take time for oneself. The Simply Perfect Sunday line is designed to help you nurture yourself, to help you rebuild and refuel so that you can start the week refreshed. While you pamper yourself you are also empowering survivors of human trafficking through meaningful employment.\n\n#9 Alluring scent: figs, toasted sugar and sweet tobacco. ",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:17.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
